module.exports = __webpack_public_path__ + "static/media/dd_logo_rec.920321ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dd_logo_rec.jpg
// module id = 2024
// module chunks = 0